@use '../../scss/utility';

@use './price-vars';
@use './price-common';

:host {
  @include price-vars.wb-price-vars;
  @include price-common.wb-price;
}

.headline {
  @include price-common.wb-price-headline;
}

.additional-text {
  @include price-common.wb-price-additional-text;
}

.value {
  @include price-common.wb-price-value;
}

.start-from {
  @include price-common.wb-price-start-from;
}

.price {
  @include price-common.wb-price-price;
}

.strike-price {
  @include price-common.wb-price-strike-price;
}

.wb-icon {
  @include price-common.wb-price-icon;
}

.wb-tooltip {
  @include price-common.wb-price-tooltip;
}

:host([size='s']) {
  .value {
    @include utility.wb-text(
      'l',
      (
        strong: true,
      )
    );
  }

  .strike-price {
    @include utility.wb-text(
      's',
      (
        strong: true,
      )
    );
  }
}

:host([size='m']) {
  .value {
    @include utility.wb-heading('xs');
  }

  .strike-price {
    @include utility.wb-text(
      'l',
      (
        strong: true,
      )
    );
  }
}

:host([size='l']) {
  .value {
    @include utility.wb-heading('s');
  }

  .strike-price {
    @include utility.wb-heading('xs');
  }
}
